const color = {
    secondred: "#ED5859", 
    yellowColor: "#FAD21A", 
    ButtonsColor: "rgba(19, 178, 188, 1)",
    danger: "#F44336",
    MainButton:"var(--Secondary, #0092C8)",
    MainColor:" var(--white, #FFF)"
  };
  
export default color;
  